import { Routes } from '@angular/router';
import { PreventionGuardService } from './@core/ping/prevention.guard';

export const routes: Routes = [
    {
        path: '',
        loadComponent: () =>
            import('./@shared/initial/initial.component').then(m => m.InitialComponent),
            canActivate: [PreventionGuardService],
        children:[
            { 
                path: '',
                redirectTo: 'home',
                pathMatch: 'full'
            },{
                path: 'home',
                loadComponent: () =>
                    import('./@module/upload/upload.component').then(m => m.UploadComponent)
            },{
                path: 'bulk',
                loadComponent: () =>
                    import('./@module/bulk/bulk.component').then(m => m.BulkComponent)
            },{
                path: 'dashboard',
                loadComponent: () =>
                    import('./@module/dashboard/dashboard.component').then(m => m.DashboardComponent)
            }
        ]
    }
   
];
